import { rolesType, TransactionType } from 'services/api/PaymentApi/types/common'
import {
  TransactionItemType,
  transactionStatusesType,
  transactionStatusWithAll,
  transactionType,
  transactionTypeWithAll,
} from 'services/api/PaymentApi/types/types'

import { sftBetStatusesEnum } from 'shared/models/Softion'

/* eslint-disable camelcase */
export interface IDefaultChangePassword {
  old_password: string
  new_password: string
}

export interface IDefaultPageFilters {
  page: number
  page_size: number
}
export interface ITransactionFilters {
  date_from?: string
  date_to?: string
  page: number
  page_size: number
  type?: PaymentTypes
  status?: PaymentStatuses
}

export const PaymentSystemNames = {
  PAGSTAR: 'pagstar',
  NOWPAYMENTS: 'nowpayments',
  ETHERONE: 'etherone',
  CODETECH: 'codetech',
  SUITPAY: 'suitpay',
  FIVERT: 'fivert',
  INTERNAL: 'internal',
  COTEDIVOIRE: 'cote_divoire',
} as const

export const PaymentMethods = {
  CARD: 'card',
  CRYPTO: 'crypto',
  PIX: 'pix',
  CASH: 'cash',
} as const
export type PaymentSystemNamesType = ReverseMap<typeof PaymentSystemNames>

export type PaymentMethodsType = ReverseMap<typeof PaymentMethods>

export interface IPaymentsHistoryItemDTO {
  type: PaymentTypes
  created_at: string
  status: PaymentStatuses
  amount: string
  currency: string
  id: number
  manual_comment: string | null
  system_name: PaymentSystemNamesType
  system_method: PaymentMethodsType
}

export interface IPaymentsHistoryItem {
  type: PaymentTypes
  createdAt: string
  status: PaymentStatuses
  amount: number
  currency: string
  paymentSystem: PaymentSystemNamesType
  paymentMethod: PaymentMethodsType
  id: string
  comment: string
}

export interface IConvertedTransactions {
  page: number
  count: number
  history: IPaymentsHistoryItem[] | []
}

interface IInitiator {
  id: number
  username: string
  role: rolesType
  parent: number
  balance_currency: string
}

interface IDepositPayout {
  id: number
  amount_currency: string
  amount: string
  extra: {}
  payment_system: { name: string }
  status: number
}

interface IDeposit extends IDepositPayout {
  payment_system: { name: string }
}
interface IPayout extends IDepositPayout {
  payout_system: { name: string }
}

export interface ITransactionListItemDTO {
  id: number
  initiator: IInitiator
  sender: IInitiator
  recipient: IInitiator
  deposit: IDepositPayout
  payout: IDepositPayout
  sender_balance_before: string
  sender_balance_after: string
  balance_before: string
  balance_after: string
  created_at: string
  player_currency_amount_currency: string
  completed_at: string
  amount_currency: string
  amount: string
  status: transactionStatusesType
  rejection_reason: string
}

export interface ITransactionListItem {
  id: number
  fromId: number
  toId: number
  amount: number
  currency: string
  createdAt: string
  completedAt: string
  status: transactionStatusesType
  description: string
  balanceBefore: string
  balanceAfter: string
  recipientBalanceAfter: string
  recipientBalanceBefore: string
  senderBalanceAfter: string
  senderBalanceBefore: string
}

export enum PaymentStatuses {
  SUCCESS = 'Success',
  STARTED = 'Started',
  FAILED = 'Failed',
  CANCELED = 'Canceled',
  MANUAL_APPROVING_REQUIRED = 'ManualApprovingRequired',
  APPROVING = 'Approving',
  APPROVING_SUCCESS = 'ApprovingSuccess',
  APPROVING_FAILED = 'ApprovingFailed',
  MANUAL_PROCESS_REQUIRED = 'ManualProcessRequired',
  FROZEN = 'Frozen',
  EXPIRED = 'Expired',
}

export enum PaymentTypes {
  DEPOSIT = 'deposit',
  PAYOUT = 'payout',
}

export enum PaymentHistoryStatuses {
  SUCCESS = 'success',
  IN_PROCESS = 'in_process',
  FROZEN = 'frozen',
  EXPIRED = 'expired',
  CANCELED = 'canceled',
  FAILED = 'failed',
}

export interface ITransactionFiltersPayload {
  dateFrom: Date
  dateTo: Date
  page: number
  pageSize: number
  type?: PaymentTypes
  status?: PaymentStatuses
}

export interface ITransactionFiltersState extends Omit<ITransactionFiltersPayload, 'type' | 'status'> {
  type: transactionTypeWithAll
  status: transactionStatusWithAll
}
